import NorthIcon from '@mui/icons-material/North';
import SouthIcon from '@mui/icons-material/South';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { convertsCentsToCurrency } from '@npi/buddy-utils';
import { Pricing } from '@prisma/client';

interface ProductCardProps {
    styling: string;
    pricings: Pricing[];
    imageUrls: Record<string, string>;
}

const ProductCard = ({ styling, pricings, imageUrls }: ProductCardProps) => {
    return (
        <Box>
            {pricings.map((pricing, index: number) => {
                return (
                    <Box key={index} sx={{ marginTop: '10px' }}>
                        <Stack>
                            <Box
                                sx={{
                                    backgroundColor: `${styling}`,
                                    color: '#fff',
                                    borderRadius: '10px 10px 0 0',
                                    padding: '20px',
                                }}
                            >
                                <h3 className="m-0">{pricing?.product?.name}</h3>
                            </Box>
                            <Box
                                sx={{
                                    borderRadius: '0 0 10px 10px',
                                    border: `thin solid ${styling}`,
                                    padding: '20px',
                                }}
                            >
                                <Grid container>
                                    <Grid item xs={7}>
                                        <Box sx={{ margin: '10px', display: 'flex' }}>
                                            <Box sx={{ marginRight: '20px' }}>
                                                <img
                                                    src={
                                                        imageUrls[pricing.product.id] ??
                                                        pricing?.product?.imageUrl
                                                    }
                                                    width="100px"
                                                    alt="image"
                                                />
                                            </Box>
                                            <Box>
                                                {pricing?.prices?.oneOff?.lowest &&
                                                    pricing?.prices?.oneOff?.highest && (
                                                    <Box sx={{ marginBottom: '20px' }}>
                                                        <Typography>One-off Limit</Typography>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                marginTop: '10px',
                                                            }}
                                                        >
                                                            <NorthIcon
                                                                sx={{
                                                                    marginRight: '10px',
                                                                    fontSize: '18px',
                                                                }}
                                                            />
                                                            <Box>
                                                                <Typography
                                                                    sx={{
                                                                        marginTop: '0px',
                                                                        fontSize: '14px',
                                                                    }}
                                                                >
                                                                    {convertsCentsToCurrency(
                                                                        pricing?.prices?.oneOff
                                                                            ?.highest
                                                                    )}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                marginTop: '5px',
                                                                marginBottom: '20px',
                                                            }}
                                                        >
                                                            <SouthIcon
                                                                sx={{
                                                                    marginRight: '10px',
                                                                    fontSize: '18px',
                                                                }}
                                                            />
                                                            <Box>
                                                                <Typography
                                                                    sx={{
                                                                        marginTop: '0px',
                                                                        fontSize: '14px',
                                                                    }}
                                                                >
                                                                    {convertsCentsToCurrency(
                                                                        pricing?.prices?.oneOff
                                                                            ?.lowest
                                                                    )}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                )}
                                                {pricing?.prices?.monthly?.lowest &&
                                                    pricing?.prices?.monthly?.highest && (
                                                    <Box>
                                                        <Typography>Monthly Limit</Typography>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                marginTop: '10px',
                                                            }}
                                                        >
                                                            <NorthIcon
                                                                sx={{
                                                                    marginRight: '10px',
                                                                    fontSize: '18px',
                                                                }}
                                                            />
                                                            <Box>
                                                                <Typography
                                                                    sx={{
                                                                        marginTop: '0px',
                                                                        fontSize: '14px',
                                                                    }}
                                                                >
                                                                    {convertsCentsToCurrency(
                                                                        pricing?.prices?.monthly
                                                                            ?.highest
                                                                    )}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                marginTop: '5px',
                                                            }}
                                                        >
                                                            <SouthIcon
                                                                sx={{
                                                                    marginRight: '10px',
                                                                    fontSize: '18px',
                                                                }}
                                                            />
                                                            <Box>
                                                                <Typography
                                                                    sx={{
                                                                        marginTop: '0px',
                                                                        fontSize: '14px',
                                                                    }}
                                                                >
                                                                    {convertsCentsToCurrency(
                                                                        pricing?.prices?.monthly
                                                                            ?.lowest
                                                                    )}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                )}
                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <Box
                                            sx={{
                                                borderLeft: `thin solid ${styling}`,
                                                paddingLeft: '20px',
                                            }}
                                        >
                                            {pricing?.prices?.options?.oneOff &&
                                                pricing?.prices?.oneOff?.lowest && (
                                                <Box sx={{ marginBottom: '20px' }}>
                                                    <Typography>One-off</Typography>
                                                    <Box
                                                        sx={{
                                                            fontSize: '12px',
                                                            marginLeft: '10px',
                                                        }}
                                                    >
                                                        <Grid container spacing={1}>
                                                            <Grid item xs={2}>
                                                                No.
                                                            </Grid>
                                                            <Grid item xs={5}>
                                                                Sales Price
                                                            </Grid>
                                                            <Grid item xs={5}>
                                                                Commission
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                    {pricing?.prices?.options?.oneOff.map(
                                                        (
                                                            { sales, commission },
                                                            index: number
                                                        ) => {
                                                            return (
                                                                <Box
                                                                    key={index}
                                                                    sx={{
                                                                        fontSize: '12px',
                                                                        marginLeft: '10px',
                                                                    }}
                                                                >
                                                                    <Grid container spacing={1}>
                                                                        <Grid item xs={2}>
                                                                            {index + 1}.
                                                                        </Grid>
                                                                        <Grid item xs={5}>
                                                                            {convertsCentsToCurrency(
                                                                                sales
                                                                            )}
                                                                        </Grid>
                                                                        <Grid item xs={5}>
                                                                            {convertsCentsToCurrency(
                                                                                commission
                                                                            )}
                                                                        </Grid>
                                                                    </Grid>
                                                                </Box>
                                                            );
                                                        }
                                                    )}
                                                </Box>
                                            )}

                                            {pricing?.prices?.options?.monthly &&
                                                pricing?.prices?.monthly?.lowest && (
                                                <Box>
                                                    <Typography>Monthly</Typography>
                                                    <Box
                                                        sx={{
                                                            fontSize: '12px',
                                                            marginLeft: '10px',
                                                        }}
                                                    >
                                                        <Grid container spacing={1}>
                                                            <Grid item xs={2}>
                                                                No.
                                                            </Grid>
                                                            <Grid item xs={5}>
                                                                Sales Price
                                                            </Grid>
                                                            <Grid item xs={5}>
                                                                Commission
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                    {pricing?.prices?.options?.monthly.map(
                                                        (
                                                            { sales, commission },
                                                            index: number
                                                        ) => {
                                                            return (
                                                                <Box
                                                                    key={index}
                                                                    sx={{
                                                                        fontSize: '12px',
                                                                        marginLeft: '10px',
                                                                    }}
                                                                >
                                                                    <Grid container spacing={1}>
                                                                        <Grid item xs={2}>
                                                                            {index + 1}.
                                                                        </Grid>
                                                                        <Grid item xs={5}>
                                                                            {convertsCentsToCurrency(
                                                                                sales
                                                                            )}
                                                                        </Grid>
                                                                        <Grid item xs={5}>
                                                                            {convertsCentsToCurrency(
                                                                                commission
                                                                            )}
                                                                        </Grid>
                                                                    </Grid>
                                                                </Box>
                                                            );
                                                        }
                                                    )}
                                                </Box>
                                            )}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Stack>
                    </Box>
                );
            })}
        </Box>
    );
};

export default ProductCard;
